import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'

import { Localized } from '../../localization/react'

import InfoIcon from './assets/info.svg'

interface Props {
  showInfoIcon?: boolean
}

// Color contrasts weren't working - now using colors from the nextjs design system palette
const CorporateBadgeComponent = ({ showInfoIcon = false }: Props) => (
  <Stack
    sx={{
      gap: 1,
      px: 2,
      py: 1,
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: '#fdf2e7',
      border: '1px solid rgba(242, 153, 74, 0.16)',
      borderRadius: 1,
      width: 'fit-content',
    }}
  >
    <Text variant="small" sx={{ fontWeight: 'bold', color: 'tertiarySelected' }}>
      <Localized id="corporate-deal-label" />
    </Text>
    {showInfoIcon && (
      <img src={InfoIcon} width="14px" height="14px" alt="Information on corporate benefits" loading="lazy" />
    )}
  </Stack>
)

export default CorporateBadgeComponent
